import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getFormValues } from 'redux-form';

import { Filter, Main } from '../../containers';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { UncloseDayForm } from './components/UncloseDayForm';
import { UNCLOSE_DAY_FORM_NAME } from 'Common/FormEnum';
import { UncloseDayEnum as Fields } from 'Common/FieldEnum';
import { MealSummaries } from './components/MealSummaries';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import {
  getMealSummaries,
  setIsSelected,
  postMealSummaries,
  clearMealSummaries,
  clearError,
} from './state/uncloseday/actions';
import { feedingOptionsEnum } from './helpers';
import moment from 'moment';
import { NotificationMessage } from 'Components/messages/ApiResultMessage';

export const pageModeEnum = {
  View: 0,
  Process: 1,
};

class UncloseDayContainer extends Component {
  currentDate = moment();

  pageMode = () => {
    if (this.props.mealSummaries.length === 0) {
      return pageModeEnum.View;
    }

    return pageModeEnum.Process;
  };

  componentDidUpdate(prevProps) {
    const { error, formValues } = this.props;
    //Check the value of each field to ensure that no value
    //has been changed. If one has been, clear the data
    if (
      (prevProps.formValues.Site &&
        prevProps.formValues.Site !== formValues.Site) ||
      prevProps.formValues.FromDate !== formValues.FromDate ||
      prevProps.formValues.ToDate !== formValues.ToDate ||
      prevProps.formValues.FeedingType !== formValues.FeedingType
    ) {
      this.props.clearMealSummaries();
    }

    if (error !== prevProps.error && error) {
      NotificationMessage(error);
      this.props.clearError();
    }
  }

  getMainProps = () => {
    return {
      toolbox: {
        formName: UNCLOSE_DAY_FORM_NAME,
        saveButtonProps: {
          loading: this.props.loading,
          content: 'Unclose Day',
          disabled: false,
        },
        shown: true,
      },
    };
  };

  loadSummaries = () => {
    const { formValues } = this.props;
    if (formValues.Site) {
      const model = {
        SiteId: formValues[Fields.Site],
        BeginDT: formValues[Fields.FromDate],
        EndDT: formValues[Fields.ToDate],
        IsSupper:
          formValues[Fields.FeedingType] === feedingOptionsEnum.Supper
            ? true
            : false,
      };

      this.props.getMealSummaries(model);
    }
  };

  onToggle = row => {
    this.props.setIsSelected(row);
  };

  onToggleAll = value => {
    const modified = this.props.mealSummaries.map(x => {
      return {
        ...x,
        IsSelected: !value.checked,
      };
    });

    modified.forEach(x => {
      this.props.setIsSelected(x);
    });
  };

  formSubmit = formValues => {
    const { mealSummaries } = this.props;

    if (mealSummaries.length > 0) {
      const model = {
        IsSupper: formValues.FeedingType,
        SiteId: formValues.Site,
        BeginDT: formValues.FromDate,
        EndDT: formValues.ToDate,
        mealSummaries: mealSummaries
          .filter(x => {
            return x.IsSelected;
          })
          .map(x => {
            return {
              MealType: x.MealType,
              UserId: x.UserId,
              ClosingDate: x.ClosingDate,
            };
          }),
      };

      this.props.postMealSummaries(model);
    }
  };

  renderMealSummaries() {
    const { mealSummaries } = this.props;

    if (this.pageMode() === pageModeEnum.View) return null;

    return (
      <MealSummaries
        data={mealSummaries}
        onChange={this.onToggle}
        onChangeAll={this.onToggleAll}
      />
    );
  }

  render() {
    return (
      <Fragment>
        <Filter title={'Unclose Day'} />
        {this.props.loadingSites ? <LoadingPage /> : undefined}
        <Main {...this.getMainProps()}>
          <UncloseDayForm
            {...this.props}
            onSubmit={this.formSubmit}
            initialValues={{
              [Fields.FeedingType]: feedingOptionsEnum.BreakfastLunchOther,
              [Fields.FromDate]: this.currentDate.format(DATE_FORMAT_FOR_UI),
              [Fields.ToDate]: this.currentDate.format(DATE_FORMAT_FOR_UI),
            }}
            getSummaries={this.loadSummaries}
          />
          {this.renderMealSummaries()}
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  const { UncloseDay } = state.UncloseDayState;
  const formValues = getFormValues(UNCLOSE_DAY_FORM_NAME)(state) || {};

  return {
    mealSummaries: UncloseDay.mealSummaries,
    loading: UncloseDay.fetching,
    loadingSites: state.CommonState.sites.loading,
    loadingUnclose: UncloseDay.fetchingUnclose,
    formValues,
    error: UncloseDay.error,
  };
};

export const UncloseDay = withRouter(
  connect(
    mapStateToProps,
    {
      getMealSummaries,
      setIsSelected,
      postMealSummaries,
      clearMealSummaries,
      clearError,
    }
  )(UncloseDayContainer)
);



// WEBPACK FOOTER //
// ./src/pages/uncloseday/UncloseDay.js